<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import event1 from '@/assets/home/event1.jpg';
import event8 from '@/assets/home/event8.png';
import event3 from '@/assets/home/event3.jpg';
import event4 from '@/assets/home/event4.jpg';
import event5 from '@/assets/home/event5.jpg';
import event6 from '@/assets/home/event6.jpg';
import event7 from '@/assets/home/event7.jpg';

const { t } = useI18n();

const events = [
  {
    image: event1,
    title: '生态大会',
    description: '培育开源人才，提升科技创新企业开源社会责任，加速社会开源创新，促进软件产业高质。',
    href: 'https://openatom.cn/conference/2025-1/index/main/',
  },
  {
    image: event8,
    title: '开发者大会',
    description: '联合多方力量，发挥产业链生态上下游的协同能力，基于开源理念共同举办。',
    href: 'https://openatom.cn/conference/2025-2/index/main/',
  },
  {
    image: event3,
    title: '开源大赛',
    description: t('home.event.content1.description'),
    href: 'https://competition.openatom.tech/',
  },
  {
    image: event4,
    title: '数据洞察',
    description: '以贡献为导向的开源人才评价平台',
    href: 'https://talent.openatom.cn/landing-page/insight',
  },
  {
    image: event5,
    title: '园区行',
    description: '助力地方开展开源生态建设和产业协同创新，推动开源技术赋能千行百业。',
    href: 'https://yuanquxing.openatom.tech/',
  },
  {
    image: event6,
    title: '人才评价',
    description: '提供以共享为导向的开源人才评价机制，定量和定性分析人员开源贡献数据。',
    href: 'https://talent.openatom.cn/',
  },
  {
    image: event7,
    title: '校源行',
    description: '通过探索产教融合新路径，为高校开发者提供更大的实践舞台，培养更多的开源综合型人才、拓展开源贡献新领域、推动开源科研成果高效转化。',
    href: 'https://xiaoyuanxing.openatom.cn/',
  },
];
</script>

<template>
  <section class="page-home-events">
    <div class="mx-auto max-w-1200 py-100 <md:py-40 <sm:px-16 <xl:px-24">
      <div class="flex items-center justify-between">
        <h2 class="relative m-0 text-40 text-#292D33 font-600 leading-60 after:absolute after:bottom--16 after:left-0 after:right-0 after:h-4 after:bg-#1281FF after:content-empty <md:text-28 <md:leading-36">
          我们的公益活动
        </h2>
      </div>

      <div class="mt-72 flex flex-wrap gap-32 <md:mt-46">
        <div v-for="(event, index) in events" :key="index" class="group h-214 w-274 overflow-hidden border-1 border-#D6DDEB rounded-8 border-solid <md:w-[calc(50%-16px)] <sm:w-full">
          <a :href="event.href" class="relative block size-full no-underline" target="_blank">
            <img :data-src="event.image" alt="" class="lazyload block size-full rounded-8 object-cover">
            <!-- 桌面端：hover 时自底部滑出的遮罩 -->
            <div
              class="absolute bottom-0 left-0 right-0 top-0 flex flex-col translate-y-100% justify-between border-1 border-#D6DDEB rounded-8 border-solid bg-[rgba(0,0,0,0.7)] p-32 transition-all duration-300 <md:hidden group-hover:translate-y-0"
            >
              <h3 class="m-0 truncate text-24 text-white font-600 leading-1.2em">
                {{ event.title }}
              </h3>
              <p class="line-clamp-2 m-0 text-14 text-white font-500 leading-1.5em" :title="event.description">
                {{ event.description }}
              </p>
              <div class="i-home-icons:arrow-right-2 size-24 text-white"></div>
            </div>
            <!-- 移动端：底部渐变条常驻显示标题，避免全黑遮罩盖住图片 -->
            <div class="absolute bottom-0 left-0 right-0 hidden flex-y-center justify-between gap-12 rounded-b-8 from-black/75 to-transparent bg-gradient-to-t px-16 pb-12 pt-40 <md:flex">
              <h3 class="m-0 truncate text-16 text-white font-600 leading-1.2em">
                {{ event.title }}
              </h3>
              <div class="i-home-icons:arrow-right-2 size-20 flex-shrink-0 text-white"></div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
